<template>
  <div>
    <b-card title="Header Görsel">
      <b-img
          v-if="dataItem.image2"
          :src="imageUrl + '/media/product_categories/' + dataItem.image2"
          thumbnail
          center
      />
      <div class="text-center mt-1">
        <b-button
            variant="primary"
            @click="setModal('product_categories2',cropperSettings.fileName)"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        :width-size="cropperSettings.widthSize"
        component="product_categories2"
        :params="cropperSettings.type"
        :item-id="dataItem.id"
        @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ImageCardHeader',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productGroups/dataItem']
    },
  },
  methods: {
    setModal(type, file) {
      const fileNamee = file?.name
      if (type === 'product_categories2') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: fileNamee,
          folder: 'product_categories',
          ratio: 1920 / 370,
          widthSize: 1920,
          type: 'product_categories2',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem.image2 = item.filename
      this.dataItem.thumb2 = item.thumb
      this.dataItem.image_webp2 = item.filename_webp
      this.dataItem.thumb_webp2 = item.thumb_webp
      this.dataItem.mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
